(function () {
  'use strict';
  if (window.top !== window || window.gaUniverseDepthV1 || !document.querySelector('.ga-u')) return;
  window.gaUniverseDepthV1 = true;
  var opened = new WeakSet();
  var searches = {};
  var searchTimer;
  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }
  function send(name, data) {
    if (!allowed() || document.hidden) return false;
    var preview = !window.Shopify || !window.Shopify.theme || window.Shopify.theme.role !== 'main';
    data.send_to = 'G-GTDP3JFKMX';
    data.content_group = 'universe';
    data.source_page = window.location.pathname;
    data.page_location = window.location.origin + window.location.pathname;
    data.universe_environment = preview ? 'preview' : 'live';
    if (preview) data.debug_mode = true;
    window.dataLayer = window.dataLayer || [];
    function event() { window.dataLayer.push(arguments); }
    event('event', name, data);
    return true;
  }
  // Capture is required because the native details toggle event does not bubble.
  document.addEventListener('toggle', function (event) {
    var detail = event.target;
    if (!detail.matches || !detail.matches('details') || !detail.open || opened.has(detail)) return;
    var world = detail.closest('[data-universe-page]');
    if (!world || !detail.closest('.ga-u') || !allowed()) return;
    var placement, selector;
    if (detail.matches('.u-discovery-card')) { placement = 'hub_subject'; selector = '.u-discovery-card'; }
    else if (detail.matches('.ga-episode-guide details')) { placement = 'hub_episode'; selector = '.ga-episode-guide details'; }
    else if (detail.matches('.u-history-chapter')) { placement = 'hub_history'; selector = '.u-history-chapter'; }
    else return;
    var position = Array.prototype.indexOf.call(world.querySelectorAll(selector), detail) + 1;
    var identifier = detail.id && /^[a-z0-9_-]+$/i.test(detail.id) ? detail.id : placement + '_' + position;
    if (send('universe_detail_open', {
      universe_show: world.getAttribute('data-universe-page'),
      universe_placement: placement,
      universe_action: 'open',
      content_id: identifier
    })) opened.add(detail);
  }, true);
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-world-search]')) return;
    if (searchTimer) clearTimeout(searchTimer);
    // Do not queue interactions made before analytics consent.
    if (!allowed() || !input.value.trim()) return;
    searchTimer = setTimeout(function () {
      if (!allowed() || !input.value.trim()) return;
      var root = input.closest('[data-world-index]');
      if (!root) return;
      var count = Array.prototype.filter.call(root.querySelectorAll('[data-world-card]'), function (card) { return !card.hidden; }).length;
      var outcome = count ? 'results' : 'no_results';
      if (searches[outcome]) return;
      // Only the outcome and count are sent. Never forward the visitor's query.
      if (send('universe_world_search', {
        universe_show: 'all',
        universe_placement: 'world_index',
        universe_action: outcome,
        result_count: count
      })) searches[outcome] = true;
    }, 800);
  });
})();
